// :cow: Cosmose CONFIDENTIAL :iso:
import { Step } from '@med/app/home/demo/guided-tour/models/step';
import { PlannerFullDemoStepEnum } from '@med/app/home/planner-full-demo/planner-full-demo-step.enum';

export const plannerFullDemoSteps: Step[] = [
  {
    stepId: PlannerFullDemoStepEnum.campaignListAddNewCampaign,
    url: '/campaigns',
    dialog: {
      description: 'page.planner.guidedTour.china.campaignListAddNewCampaign.description',
      nextStepDescription: 'page.planner.guidedTour.china.campaignListAddNewCampaign.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="campaignListAddNewCampaign"] button',
      exposedElement: {
        selector: '[data-demo-planner-full="campaignListAddNewCampaign"] button',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.campaignObjectiveSelectNewStoreOpening,
    url: '/objective',

    dialog: {
      description: 'page.planner.guidedTour.china.campaignObjectiveSelectNewStoreOpening.description',
      nextStepDescription: 'page.planner.guidedTour.china.campaignObjectiveSelectNewStoreOpening.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="campaignObjectiveSelectNewStoreOpening"] .objective__option--name:first-child',

      exposedElement: {
        selector: '[data-demo-planner-full="campaignObjectiveSelectNewStoreOpening"] .objective__option--name:first-child .list-item',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.plannerStartSelectAudience,
    url: '/campaign/demo/planner-full',
    dialog: {
      description: 'page.planner.guidedTour.china.plannerStartSelectAudience.description',
      nextStepDescription: 'page.planner.guidedTour.china.plannerStartSelectAudience.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="plannerStartSelectAudience"]',

      exposedElement: {
        selector: '[data-demo-planner-full="plannerStartSelectAudience"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceShowEstimates,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceShowEstimates.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceShowEstimates"]',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceReadSegmentDescriptions,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.audience.ownStoresTooltip',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceReadSegmentDescriptions"]',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceSelectCompetitors,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceSelectCompetitors.description',
      nextStepDescription: 'page.planner.guidedTour.china.audienceSelectCompetitors.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceSelectCompetitors"]',
      exposedElement: {
        selector: '[data-demo-planner-full="audienceSelectCompetitors"] .selectable-tile-list__tile:nth-child(10)',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceShowEstimatesChange,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceShowEstimatesChange.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceShowEstimates"]',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceSelectLocationCategories,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceSelectLocationCategories.description',
      nextStepDescription: 'page.planner.guidedTour.china.audienceSelectLocationCategories.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceSelectLocationCategories"]',
      exposedElement: {
        selector: '[data-demo-planner-full="audienceSelectLocationCategories"] .selectable-tile:not(.selectable-tile--active)',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceExplainAddingLocationCategories,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceExplainAddingLocationCategories.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceSelectLocationCategories"]',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceAskToSelectCity,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceAskToSelectCity.description',
      nextStepDescription: 'page.planner.guidedTour.china.audienceAskToSelectCity.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceAskToSelectCity"]',
      exposedElement: {
        selector: '[data-demo-planner-full="audienceAskToSelectCity"] .tiered-cities__collapsable-tier:nth-child(2) .selectable-tile-list__tile:nth-child(2) .selectable-tile',
        preventDefault: false,
      },
    },
  },

  {
    stepId: PlannerFullDemoStepEnum.audienceShowTimespan,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceShowTimespan.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceShowTimespan"]',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.audienceAskToClickContinue,
    url: '/campaign/demo/planner-full/audience',
    dialog: {
      description: 'page.planner.guidedTour.china.audienceAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.audienceAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="audienceAskToClickContinue"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="audienceAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },

  {
    stepId: PlannerFullDemoStepEnum.demographicsSelectGender,
    url: '/campaign/demo/planner-full/groups',
    dialog: {
      description: 'page.planner.guidedTour.china.demographicsSelectGender.description',
      nextStepDescription: 'page.planner.guidedTour.china.demographicsSelectGender.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="demographicsSelectGender"]',

      exposedElement: {
        selector: '[data-demo-planner-full="demographicsSelectGender"]',
        preventDefault: false,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.demographicsAskToClickContinue,
    url: '/campaign/demo/planner-full/groups',
    dialog: {
      description: 'page.planner.guidedTour.china.demographicsAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.demographicsAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="demographicsAskToClickContinue"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="demographicsAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.budgetSelectCampaignDuration,
    url: '/campaign/demo/planner-full/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.budgetSelectCampaignDuration.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="budgetSelectCampaignDuration"]',

    },
  },
  {
    stepId: PlannerFullDemoStepEnum.budgetCalculationExplanation,
    url: '/campaign/demo/planner-full/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.budgetCalculationExplanation.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="budgetCalculationExplanation"]',

    },
  },
  {
    stepId: PlannerFullDemoStepEnum.budgetAskToClickContinue,
    url: '/campaign/demo/planner-full/budget',
    dialog: {
      description: 'page.planner.guidedTour.china.budgetAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.budgetAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="budgetAskToClickContinue"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="budgetAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.mediaSearchPlatform,
    url: '/campaign/demo/planner-full/media',
    dialog: {
      description: 'page.planner.guidedTour.china.mediaSearchPlatform.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="mediaSearchPlatform"] .mat-form-field-flex',
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.mediaSelectFormat,
    url: '/campaign/demo/planner-full/media',
    dialog: {
      description: 'page.planner.guidedTour.china.mediaSelectFormat.description',
      nextStepDescription: 'page.planner.guidedTour.china.mediaSelectFormat.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
      offset: {top: -260, left: -150},
    },
    portal: {
      selector: '[data-demo-planner-full="mediaSelectFormat"] e-media-platform:nth-child(1) .mat-option',
      exposedElement: {
        selector: '[data-demo-planner-full="mediaSelectFormat"] e-media-platform:nth-child(1) .mat-option',
        preventDefault: false,
      },
      padding: {top: 250, left: 40, right: 40},
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.mediaAskToClickContinue,
    url: '/campaign/demo/planner-full/media',
    dialog: {
      description: 'page.planner.guidedTour.china.mediaAskToClickContinue.description',
      nextStepDescription: 'page.planner.guidedTour.china.mediaAskToClickContinue.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      isFixed: true,
      selector: '[data-demo-planner-full="mediaAskToClickContinue"]',
      exposedElement: {
        selector: '[data-demo-planner-full="mediaAskToClickContinue"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.spotplanAnalyze,
    url: '/campaign/demo/planner-full/timeline',
    dialog: {
      description: 'page.planner.guidedTour.china.spotplanAnalyze.description',
      hideExitDemo: false,
      displayNextStepButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="spotplanAnalyze"]',
    },
  },

  {
    stepId: PlannerFullDemoStepEnum.spotplanAskToClickSummary,
    url: '/campaign/demo/planner-full/timeline',
    dialog: {
      description: 'page.planner.guidedTour.china.spotplanAskToClickSummary.description',
      nextStepDescription: 'page.planner.guidedTour.china.spotplanAskToClickSummary.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="spotplanAskToClickSummary"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="spotplanAskToClickSummary"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.summaryAskToClickSendForReview,
    url: '/campaign/demo/summary',
    dialog: {
      description: 'page.planner.guidedTour.china.summaryAskToClickSendForReview.description',
      nextStepDescription: 'page.planner.guidedTour.china.summaryAskToClickSendForReview.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="summaryAskToClickSendForReview"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="summaryAskToClickSendForReview"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.sentForReviewAskToClickBackToDashboard,
    url: '/campaign/demo/success',
    dialog: {
      description: 'page.planner.guidedTour.china.sentForReviewAskToClickBackToDashboard.description',
      nextStepDescription: 'page.planner.guidedTour.china.sentForReviewAskToClickBackToDashboard.nextStepDescription',
      hideExitDemo: false,
      displayNextStepButton: false,
    },
    portal: {
      selector: '[data-demo-planner-full="sentForReviewAskToClickBackToDashboard"]',
      isFixed: true,
      exposedElement: {
        selector: '[data-demo-planner-full="sentForReviewAskToClickBackToDashboard"]',
        preventDefault: true,
      },
    },
  },
  {
    stepId: PlannerFullDemoStepEnum.campaignListExposeCampaign,
    url: '/campaigns?page=0&size=12&sortBy=createdTime&sortDir=desc',
    dialog: {
      description: 'page.planner.guidedTour.china.campaignListExposeCampaign.description',
      hideExitDemo: true,
      displayNextStepButton: false,
      displayExitCampaignButton: true,
    },
    portal: {
      selector: '[data-demo-planner-full="campaignListExposeCampaign"] .list-element',
    },
  },
];
